import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
    Badge,
    Card,
    Dropdown,
    DropdownMenu,
    DropdownToggle,
    Table
} from "reactstrap";
import { getSchedulerDetails } from "../../../store/deviceDetails/actions";
import VWLoading from "../../../components/vwLoading/vwLoading";
import Message from "../../../CommonData/Data/Message";
import NoRecord from "../../../CommonData/norecord/norecord";

const style = {
    table: {
        width: '100%',
        display: 'table',
        borderSpacing: 0,
        borderCollapse: 'separate',
    },
    th: {
        top: 0,
        left: 0,
        zIndex: 2,
        position: 'sticky',
        backgroundColor: '#fff',
    },
};

const SwitchDetails = (props) => {
    const { masterDeviceDetails, deviceID } = props;
    const [deviceDetails, setDeviceDetails] = useState();
    const [switchList, setSwitchList] = useState();
    const [open, setOpen] = useState([]);
    const [schedulerDetails, setSchedulerDetails] = useState();
    const [schedulerName, setSchedulerName] = useState();
    const [schedulerError, setSchedulerError] = useState();
    const [schedulerLoading, setSchedulerLoading] = useState(false);

    useEffect(() => {
        if (masterDeviceDetails && deviceID) {
            const deviceArray = masterDeviceDetails && masterDeviceDetails.assignedDevices && masterDeviceDetails.assignedDevices.filter((i) => i.id === deviceID);
            const deviceObj = deviceArray && deviceArray.length > 0 ? deviceArray[0] : {};
            const switchData = deviceObj && deviceObj.switches;
            setSwitchList(switchData)
            setDeviceDetails(deviceObj);
        }
    }, [masterDeviceDetails])

    // ----------------------------------------SORTING-----------------------------------------------------------//
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortOrder, setSortOrder] = useState(null);
    const handleSort = (column) => {
        if (sortOrder === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortOrder(column);
            setSortDirection('asc');
        }
    };
    switchList && switchList.sort((a, b) => {
        if (sortOrder === 'switchNo' || sortOrder === 'isEnabled') {
            const aVal = parseFloat(a[sortOrder] || 0);
            const bVal = parseFloat(b[sortOrder] || 0);
            return sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
        }
        else {
            const aValue = a[sortOrder] || 'NA';
            const bValue = b[sortOrder] || 'NA';
            return sortDirection === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
        }
    });

    const handleSchedulerData = (e, id, name) => {
        e.preventDefault();
        const selectedSwitch = [...open];
        const isAlreadyPresent = selectedSwitch && selectedSwitch.findIndex((i) => i.id === id)
        selectedSwitch && selectedSwitch.map((i) => {
            if (i.id !== id) {
                return i.isOpen = false
            }
        });

        if (isAlreadyPresent === -1) {
            selectedSwitch.push({ id: id, isOpen: true })
        }
        else {
            selectedSwitch[isAlreadyPresent].isOpen = selectedSwitch[isAlreadyPresent].isOpen ? false : true;
        }

        setOpen(selectedSwitch)

        if (id) {
            setSchedulerLoading(true);
            props.getSchedulerDetails(id)
                .then((result) => {
                    setSchedulerLoading(false);
                    setSchedulerError();
                    setSchedulerName(name);
                    if (result) {
                        const { schedulerconfig } = result || {};
                        const newArr = Object.entries(schedulerconfig);
                        newArr && newArr.map((ele) => {
                            return ele.splice(0, 1, [{ day: ele[0] }])
                        })
                        const combinedArr = newArr && newArr.map((i) => i.flat());
                        const reduceArr = combinedArr && combinedArr.filter((ele) => ele.length > 1);
                        const finArr = reduceArr && reduceArr.map((ele) => {
                            return ele.map((i) => {
                                return {
                                    ...i,
                                    day: ele[0].day
                                }
                            })
                        })
                        finArr && finArr.map((ele) => {
                            return ele.splice(0, 1)
                        })
                        const schedulerData = [];
                        const mergedArr = finArr.flat();
                        mergedArr && mergedArr.map((ele) => {
                            const index = schedulerData && schedulerData.findIndex((i) => (ele.actionTime === i.actionTime) && (ele.status === i.status));
                            let temObj = {};
                            if (index === -1) {
                                temObj = {
                                    actionTime: ele.actionTime,
                                    days: [ele.day],
                                    status: ele.status,
                                    isActionExecuted: ele.isActionExecuted
                                }
                                return schedulerData.push(temObj);
                            }
                            else {
                                return schedulerData[index].days.push(ele.day);
                            }
                        })
                        setSchedulerDetails(schedulerData);
                    }
                })
                .catch((err) => {
                    setSchedulerName(name);
                    setSchedulerError(err);
                    setSchedulerLoading(false);
                })
        }
    }

    return (
        <div>
            <div>
                <Table borderless responsive>
                    <tbody>
                        <tr>
                            <td>
                                <span className="fw-bold"> Serial Number : </span>{(deviceDetails && deviceDetails.deviceKey) || "NA"}
                            </td>
                            <td>
                                <span className="fw-bold">Device Name : </span>{(deviceDetails && deviceDetails.name) || "NA"}
                            </td>
                            <td>
                                <span className="fw-bold">Group Name : </span>{(deviceDetails && deviceDetails.group && deviceDetails.group.name) || "NA"}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span className="fw-bold">Room Name : </span>{(deviceDetails && deviceDetails.roomName) || "NA"}
                            </td>
                            <td>
                                <span className="fw-bold">Room Number : </span>{(deviceDetails && deviceDetails.roomNo) || "NA"}
                            </td>
                            <td>
                                <span className="fw-bold">Status : </span>{deviceDetails && deviceDetails.isActive ?
                                    <Badge color="primary">Active</Badge>
                                    : <Badge color="danger">Inactive</Badge>
                                }
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div >
            <div style={{ minHeight: "300px", maxHeight: "600px", overflowX: "auto" }}>
                <Table size="sm" className="table table-hover table-nowrap w-100" style={style.table}>
                    <thead className='overflow-hidden sticky-top' style={{ backgroundColor: "white", overflow: "hidden", zIndex: "10" }}>
                        <th onClick={() => handleSort('switchName')} style={{ cursor: "pointer" }}>
                            SWITCH NAME
                            {sortOrder === 'switchName' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                        </th>
                        <th onClick={() => handleSort('switchCategory')} style={{ cursor: "pointer" }}>
                            SWITCH CATEGORY
                            {sortOrder === 'switchCategory' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                        </th>
                        <th onClick={() => handleSort('switchNo')} style={{ cursor: "pointer" }}>SWITCH NUMBER
                            {sortOrder === 'switchNo' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                        </th>
                        <th>SCHEDULER</th>
                        <th onClick={() => handleSort('isEnabled')} style={{ cursor: "pointer" }}>
                            SWITCH STATUS
                            {sortOrder === 'isEnabled' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                        </th>
                    </thead>
                    <tbody>
                        {switchList && switchList.length > 0 ?
                            switchList.map((switchData) => {
                                return (
                                    <tr className="align-middle">
                                        <td>{switchData.switchName}</td>
                                        <td>{switchData.switchCategory}</td>
                                        <td>{switchData.switchNo}</td>
                                        <td>
                                            <Dropdown
                                                style={{ width: "max-content" }}
                                                isOpen={
                                                    open && open.filter((i) => i.id === switchData.id).length > 0 ?
                                                        open.filter((i) => i.id === switchData.id)[0].isOpen
                                                        : false
                                                }
                                                onClick={(e) => {
                                                    if (!(Number(switchData.switchNo) === 2 || Number(switchData.switchNo) === 3)) {
                                                        handleSchedulerData(e, switchData.id, switchData.switchName)
                                                    }
                                                }}
                                                toggle={(e) => {
                                                    e.preventDefault();
                                                    setOpen([]);
                                                    setSchedulerDetails();
                                                }}
                                            >
                                                <DropdownToggle className="bg-white border-0" disabled={Number(switchData.switchNo) === 2 || Number(switchData.switchNo) === 3}>
                                                    <i class="fas fa-calendar-week fs-5 text-secondary"></i>
                                                </DropdownToggle>
                                                <DropdownMenu style={{ backgroundColor: "#E7F2F8", maxHeight: "400px", overflowY: "auto" }} onClick={(e) => e.preventDefault()}>
                                                    <div className="pt-2 pb-0 px-3">
                                                        <div className="fs-5 fw-bold mb-2 text-nowrap">Switch Name : {schedulerName}</div>
                                                        {schedulerLoading ?
                                                            <VWLoading height={40} width={40} />
                                                            : schedulerDetails && schedulerDetails.length > 0 ?
                                                                schedulerDetails.map((data) => {
                                                                    const isSunday = data.days && data.days.filter((day) => day === "sunday").length > 0;
                                                                    const isMonday = data.days && data.days.filter((day) => day === "monday").length > 0;
                                                                    const isTuesday = data.days && data.days.filter((day) => day === "tuesday").length > 0;
                                                                    const isWednesday = data.days && data.days.filter((day) => day === "wednesday").length > 0;
                                                                    const isThursday = data.days && data.days.filter((day) => day === "thursday").length > 0;
                                                                    const isFriday = data.days && data.days.filter((day) => day === "friday").length > 0;
                                                                    const isSaturday = data.days && data.days.filter((day) => day === "saturday").length > 0;
                                                                    return (
                                                                        <Card className=" p-2 pb-0 mb-2 shadow-lg">
                                                                            <div className="d-flex text-nowrap gap-4 mb-2 ">
                                                                                <div className="d-flex align-items-center">
                                                                                    <div></div>
                                                                                    <div><span className="fw-bold">Time : </span>{data.actionTime.slice(0, -3)} <i class="fas fa-clock text-primary" /></div>
                                                                                </div>
                                                                                <div><span className="fw-bold">Switch Status :</span> {data.status ? <Badge color="primary" pill>ON</Badge> : <Badge color="danger" pill>OFF</Badge>}</div>
                                                                            </div>
                                                                            <div className="d-flex gap-2 align-items-center justify-content-center pb-2">
                                                                                <Card color={isSunday ? "primary" : "secondary"} className="px-2 py-1 mb-0 text-white">S</Card>
                                                                                <Card color={isMonday ? "primary" : "secondary"} className="px-2 py-1 mb-0 text-white">M</Card>
                                                                                <Card color={isTuesday ? "primary" : "secondary"} className="px-2 py-1 mb-0 text-white">T</Card>
                                                                                <Card color={isWednesday ? "primary" : "secondary"} className="px-2 py-1 mb-0 text-white">W</Card>
                                                                                <Card color={isThursday ? "primary" : "secondary"} className="px-2 py-1 mb-0 text-white">T</Card>
                                                                                <Card color={isFriday ? "primary" : "secondary"} className="px-2 py-1 mb-0 text-white">F</Card>
                                                                                <Card color={isSaturday ? "primary" : "secondary"} className="px-2 py-1 mb-0 text-white">S</Card>
                                                                            </div>
                                                                        </Card>
                                                                    )
                                                                })
                                                                : schedulerError && typeof (schedulerError) === "string" ?
                                                                    <Message
                                                                        type="danger"
                                                                        defaultMessage={schedulerError}
                                                                        baseClassName="alert"
                                                                    />
                                                                    :
                                                                    <div className="text-danger fs-6 text-center text-nowrap">
                                                                        <i class="fas fa-database"></i> &nbsp; No Routine Found.
                                                                    </div>
                                                        }
                                                    </div>
                                                </DropdownMenu>
                                            </Dropdown>
                                        </td>
                                        <td>{switchData.isEnabled ? <Badge color="primary">Enabled</Badge> : <Badge color="danger">Disabled</Badge>}</td>
                                    </tr>
                                )
                            })
                            : <tr>
                                <td colSpan={6}>
                                    <NoRecord />
                                </td>
                            </tr>
                        }
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    masterDeviceDetails: state.deviceDetails.masterDevice,
    deviceID: state.deviceDetails.selectedDeviceId,
})
const mapDispatchToProps = (dispatch) => ({
    getSchedulerDetails: (id) => dispatch(getSchedulerDetails(id)),
})
export default connect(mapStateToProps, mapDispatchToProps)(SwitchDetails);